import { Component, Prop, Event, EventEmitter, h } from '@stencil/core';
import { Color } from '../../interface';

@Component({
  tag: 'lar-inner-range-inception-door-content',
  shadow: false,
  scoped: false
})
export class InnerRangeAreaDoorContent {
   @Prop() color?: Color;
   @Prop() disabled?: boolean;
   @Prop() value: string;
   @Prop() icon: string;
   // @Event() click!: EventEmitter; // populates

   render() {
    return [
      <lar-button disabled={this.disabled} color={this.color}><lar-icon icon={this.icon} /> <lar-translate t={this.value} /></lar-button>
    ];
  }
}